import React, { useState } from 'react';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import clsx from 'clsx';
import { formatISO } from 'date-fns';
import { useFormContext } from 'react-hook-form';
import get from 'lodash.get';
import { DateTimePicker } from 'services/Main/types.Field';
import isValidDate from 'utils/isValidDate';
import { formatDate } from 'utils/formatDate';
import { DATE_TIME_FORMAT } from 'commonConstants';
import { getDate } from '../../helpers';
import { useFormatMessage } from '../../../../../locale';
import useStyles from '../../DatePicker.styles';

type DateTimeProps = DateTimePicker & {
  value?: any;
  onChange?: any;
};

export default ({
  disabled,
  value,
  onChange,
  initialFocusedDate,
  label,
  minDate,
  maxDate,
  name,
  helperText,
  autoComplete,
}: DateTimeProps) => {
  const classes = useStyles();
  const formatMessage = useFormatMessage();
  const { errors } = useFormContext();
  const [internalError, setInternalError] = useState<string | null>(null);

  const error = get(errors, name);

  const handleChange = (date: MaterialUiPickersDate) => {
    if (isValidDate(date) || date === null) {
      setInternalError(null);
      onChange(date ? formatISO(date) : null);
    } else {
      setInternalError(
        formatMessage('enterTheCorrectDateFormat', {
          date: formatDate(new Date(), 'dateTime'),
        })
      );
    }
  };

  return (
    <KeyboardDateTimePicker
      ampm={false}
      autoOk
      clearable
      fullWidth
      showTodayButton
      label={label}
      minDate={minDate}
      maxDate={maxDate}
      name={name}
      value={getDate(value)}
      KeyboardButtonProps={{
        className: clsx(classes.keyboardButton, { disabled }),
      }}
      helperText={error?.message || internalError || helperText}
      error={!!error}
      onChange={handleChange}
      initialFocusedDate={getDate(initialFocusedDate, new Date())}
      format={DATE_TIME_FORMAT}
      disabled={disabled}
      InputProps={{
        autoComplete: autoComplete || 'off',
      }}
      clearLabel={formatMessage('clear')}
      todayLabel={formatMessage('today')}
      cancelLabel={formatMessage('cancel')}
    />
  );
};
